import { render, staticRenderFns } from "./pos-add.vue?vue&type=template&id=727e7957&"
import script from "./pos-add.vue?vue&type=script&lang=js&"
export * from "./pos-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports